export class UpdatePlaceListStatus {
    storeConsumptionId: number;
    rackPosition: number;
    reportedCases?: number;
    constructor(storeConsumptionId: number,rackPosition: number,reportedCases?: number){
        this.storeConsumptionId = storeConsumptionId
        this.rackPosition = rackPosition
        this.reportedCases = reportedCases
    }
}